import React from 'react';
import {
  Stack as MuiStack,
  type StackProps as MuiStackProps,
} from '@mui/material';
import { splitSystemProps, type SystemShorthandProps } from '../systemProps';

export type StackProps = MuiStackProps & SystemShorthandProps;

export default function Stack({ children, sx, ...props }: StackProps) {
  const split = splitSystemProps(props, sx);
  return (
    <MuiStack {...split.rest} sx={split.sx}>
      {children}
    </MuiStack>
  );
} //todo endre navn på denne.
